import React, { useEffect, useState } from 'react';
import { CONTACT_LINE } from '../../data/studyText';
import './Complete.css';

// Only ever redirect to a real http(s) URL the server released — never a placeholder
// (an empty/placeholder redirect would strand a paid participant).
const validUrl = (u: string | null): u is string =>
  !!u && /^https?:\/\/.+/i.test(u) && !/placeholder|example\.com|YOUR_/i.test(u);

const Complete: React.FC = () => {
  const [completionUrl, setCompletionUrl] = useState<string | null>(null);
  const [completionCode, setCompletionCode] = useState<string | null>(null);
  const [platform, setPlatform] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);
  const [sonaId, setSonaId] = useState<string | null>(null);

  useEffect(() => {
    // Read the Prolific completion target persisted by the Debrief BEFORE clearing
    // the rest of the experiment session data.
    let url: string | null = null;
    let code: string | null = null;
    try {
      url = localStorage.getItem('prolificCompletionUrl');
      code = localStorage.getItem('prolificCompletionCode');
      setPlatform(localStorage.getItem('completionPlatform'));
      setFailed(localStorage.getItem('completionFailed') === 'true');
      setSonaId(localStorage.getItem('sonaId'));
    } catch {}
    setCompletionUrl(url);
    setCompletionCode(code);

    // Clear experiment data (leave the completion url/code in place until the
    // participant has been redirected / read their code).
    try {
      localStorage.removeItem('experimentSession');
      localStorage.removeItem('participantId');
      localStorage.removeItem('hasConsented');
      localStorage.removeItem('consentedArm');
      localStorage.removeItem('emailDecisions');
      localStorage.removeItem('deviceDecisions');
      localStorage.removeItem('assignedRotation');
      localStorage.removeItem('mainArmInterface');
    } catch (e) {
      // localStorage may be unavailable in private browsing
    }

    console.log('Experiment completed successfully');

    // Auto-redirect back to Prolific once, only if the server released a real URL.
    if (validUrl(url)) {
      const timer = setTimeout(() => {
        window.location.href = url as string;
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <div className="complete-phase">
      <div className="complete-content">
        <div className="complete-icon">✓</div>
        <h1>Study Complete</h1>
        <p className="thank-you">
          <b>Thank you — you're done.</b>
        </p>

        {validUrl(completionUrl) ? (
          <p className="closing" style={{ marginTop: '30px', color: '#666' }} data-testid="complete-redirect">
            {platform === 'sona' ? 'Your SONA credit is being recorded. You will be returned to SONA in a few seconds' : 'You will be returned to Prolific in a few seconds'}; if that does not happen,{' '}
            <a href={completionUrl as string}>click here</a>. You can close this tab afterwards.
            {completionCode && (
              <> Your completion code is <b>{completionCode}</b>.</>
            )}
          </p>
        ) : completionCode ? (
          <p className="closing" style={{ marginTop: '30px', color: '#666' }}>
            Your Prolific completion code is <b>{completionCode}</b>. Enter it in Prolific to
            confirm your submission, then you may close this window.
          </p>
        ) : failed || platform === 'sona' ? (
          <p className="closing" style={{ marginTop: '30px', color: '#666' }} data-testid="complete-manual">
            We could not post your SONA credit automatically. Please email {CONTACT_LINE}
            {sonaId ? <> with this reference: <b>{sonaId}</b></> : null} and we will post your credit within
            two working days. Keep this page open until you have copied the reference.
          </p>
        ) : (
          <p className="closing" style={{ marginTop: '30px', color: '#666' }}>
            You may now close this window.
          </p>
        )}
      </div>
    </div>
  );
};

export default Complete;
